import { BodyText, Flex, ListItem } from '@utilitywarehouse/hearth-react';

import { CopyButton } from '@components/CopyButton';

import './styles.scss';

interface LobbyDetailsItemProps {
  value: string;
  preview: string;
  label: string;
  testId?: string;
  onCopy?: (value: string) => void;
}

const LobbyDetailsItem = ({
  value,
  preview,
  label,
  testId,
  onCopy = () => {},
}: LobbyDetailsItemProps) => {
  return (
    <ListItem
      direction="row"
      alignItems="center"
      justifyContent="between"
      className="remote__LobbyDetailsItem"
    >
      <Flex
        direction="column"
        spacing="xs"
        className="remote__LobbyDetailsItemContent"
      >
        <BodyText
          size="lg"
          className="remote__LobbyDetailsItemPreview"
          title={preview}
          data-testid={testId}
        >
          {preview}
        </BodyText>
        <BodyText size="md" color="secondary">
          {label}
        </BodyText>
      </Flex>
      <CopyButton
        buttonProps={{
          size: 'sm',
          variant: 'ghost',
          colorScheme: 'functional',
        }}
        value={value}
        onCopy={onCopy}
        iconButton
      />
    </ListItem>
  );
};

export { LobbyDetailsItem };
